import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { formatCurrency, formatNumber } from '@angular/common';

@Pipe({
    name: 'money',
    standalone: true
})
export class MoneyPipe implements PipeTransform {

    constructor(@Inject(LOCALE_ID) private locale: string) {}

    transform(value: unknown, ...args: unknown[]): unknown {
        const currency = (args[0] || 'USD') as string;
        let currencyCode = '';
        if (args[1] !== false) {
            switch (currency) {
                case 'USD':
                case 'CAD':
                    currencyCode = '$';
                    break;
            }
        }
        return currencyCode + formatNumber(value as number, this.locale, '1.2-2');
    }

}
